module.exports = __webpack_public_path__ + "img/emoticon-nps-9-on.a54af559.svg";